import { Component, Inject } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { userInfo } from 'src/models/userModels';
import { NotificationBar } from 'src/services/notification.service';
import { ConfirmDialogDialog } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-settings-user',
  templateUrl: './settings-user.component.html',
  styleUrl: './settings-user.component.scss'
})
export class SettingsUserComponent {
  workspaceGroup = new FormGroup({
    userEmailControl: new FormControl('', [Validators.required, Validators.email])
  });
  isProcessing = false;
  notificationBar: NotificationBar;
  workspaceID = "";
  userList = new Array<userInfo>();
  userForRemove: string;
  changesMade = false;
  
  constructor(public dialogRef: MatDialogRef<SettingsUserComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private snackBar: MatSnackBar,  private fireFunctions: AngularFireFunctions, public dialog: MatDialog) {
    this.notificationBar = new NotificationBar(snackBar);
    this.workspaceID = data.workspaceID;
  }

  ngOnInit() {
    this.loadAllUser();
    this.dialogRef.backdropClick().subscribe( x => {
      this.dialogRef.close(this.changesMade);
    });
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.dialogRef.close(this.changesMade);
      }
    });
  }

  loadAllUser() {
    this.userList = new Array<userInfo>();
    var workspaceID = this.workspaceID;
    this.fireFunctions.httpsCallable("esportsms-getAllUser")({workspaceID}).subscribe( res => {
      this.isProcessing = false;
      if (res) {
        this.userList = res;
        this.userList.sort((a, b) => a.displayName.localeCompare(b.displayName));
      }
      else {
        this.notificationBar.show("User not found!");
      }
    }, err => {
      this.isProcessing = false;
      console.log(err)
      if (err.code == "functions/not-found") {
        this.notificationBar.show("User not found!");
      }
      else if (err.code == "functions/permission-denied") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
  }

  async addWorkspaceUser() {
    this.isProcessing = true;
    var newUserEmail = this.workspaceGroup.controls.userEmailControl.value;
    var workspaceID = this.workspaceID;
    this.fireFunctions.httpsCallable("esportsms-addWorkspaceUser")({newUserEmail, workspaceID}).subscribe( res => {
      this.isProcessing = false;
      if (res) {
        this.workspaceGroup.controls.userEmailControl.setValue("");
        this.workspaceGroup.controls.userEmailControl.setErrors(null);
        this.notificationBar.show("User added!");
        this.changesMade = true;
        this.loadAllUser();
      }
      else {
        this.notificationBar.show("User not found!");
      }
    }, err => {
      this.isProcessing = false;
      if (err.code == "functions/not-found") {
        this.notificationBar.show("User not found!");
      }
      else if (err.code == "functions/permission-denied") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
  }

  async removeUser(uid: string) {
    this.userForRemove = uid;
    var workspaceID = this.workspaceID;
    var user = this.userList.find(x => x.uid == uid);
    var dialogRef = this.dialog.open(ConfirmDialogDialog, {
      data: {
        actionType: "remove",
        message: "Are you sure you want to remove " + user.email + "?",
      }
    });
    return dialogRef.afterClosed().toPromise().then(async res => {
      if (res == true) {
        this.fireFunctions.httpsCallable("esportsms-removeWorkspaceUser")({uid, workspaceID}).subscribe( res => {
          this.userForRemove = "";
          this.loadAllUser();
          if (res) {
            this.notificationBar.show("User removed!");
            this.changesMade = true;
          }
          else {
            this.notificationBar.show("User not found!");
          }
          this.loadAllUser();
        }, err => {
          this.userForRemove = "";
          this.loadAllUser();
          if (err.code == "functions/not-found") {
            this.notificationBar.show("User not found!");
          }
          else if (err.code == "functions/permission-denied") {
            this.notificationBar.show("Missing permission!");
          }
          else {
            this.notificationBar.showUnknownError();
          }
        });
      }
      else {
        this.userForRemove = "";
      }
    });
  }

  getErrorEmail() {
    return this.workspaceGroup.controls.userEmailControl.hasError('email') ? 'Not a valid email' : '';
  }
}
